import React, { useLayoutEffect, useState } from 'react';
import InfoDialog from '../../../components/shared/InfoDialog';
import { useTranslation } from 'react-i18next';
import { useEventListener } from 'usehooks-ts';
import AccountInfo from '../users/menu/AccountInfo';
import ShowContainer from '../../../components/material-ui/ShowContainer';
import InformationLinks from '../users/menu/InformationLinks';
import MenuActions from '../users/menu/MenuActions';
import { Stack } from '@mui/material';

export default function UserInfoMobile({ open, closeModal, viewUserId }) {
  const { t } = useTranslation();
  const [infoUser, setInfoUsr] = useState({});

  const infoUserId = infoUser.userId;

  useEventListener('userMenu.userInfo.get', (e) => {
    const { selectUserFull } = e.detail;

    if (viewUserId == selectUserFull.userId) {
      setInfoUsr(selectUserFull);
    }
  });

  // TODO CHECK
  useLayoutEffect(() => {
    if (!viewUserId) return;
    if (!infoUserId) return;

    if (viewUserId !== infoUserId) {
      setInfoUsr({});
    }
  }, [viewUserId, infoUserId]);

  return (
    <InfoDialog
      open={open && infoUserId}
      onClose={closeModal}
      title={`${t('Account')}`}
      maxWidth="xs">
      <Stack gap={2}>
        <AccountInfo selectUserFull={infoUser} setSelectUserFull={setInfoUsr} PinElement={null} />
        <InformationLinks selectUserFull={infoUser} />
        <MenuActions user={infoUser} setSelectUserFull={setInfoUsr} hideAddUser />
      </Stack>
    </InfoDialog>
  );
}
